import Translate from 'react-translate-component';
import React, { PropTypes } from 'react';

class PaymentStart extends React.Component {
  static propTypes = {
    payment: PropTypes.object.isRequired,
    cancel: PropTypes.func.isRequired,
    createPaymentRequest: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props);

    this.state = {
      showInvoiceSpecification: false,
      showPlusgiroInfo: false
    };
  }

  swishUrl = () => {
    return 'swish://paymentrequest?token=' +
       this.props.payment.paymentRequest.data.attributes.token +
       '&callbackurl=' +
       this.swishCallbackUrl();
  }

  swishCallbackUrl = () => {
    return window.location.href + '/status';
  }

  startPayment = (event) => {
    event.preventDefault();
    this.props.createPaymentRequest(this.props.payment.invoice.data.uuid).then(() => {
      window.location.href = this.swishUrl();
    });
  }

  toggleInvoiceSpecification = () => {
    this.setState({
      showInvoiceSpecification: !this.state.showInvoiceSpecification,
      showPlusgiroInfo: false
    });
  }

  togglePlusgiroInfo = () => {
    this.setState({
      showInvoiceSpecification: false,
      showPlusgiroInfo: !this.state.showPlusgiroInfo
    });
  }

  renderInvoiceSpecificationButton = () => {
    let translationKey = this.state.showInvoiceSpecification ? 'MINIMIZE' : 'SEE_INVOICE_SPECIFICATION';
    return (
      <button className='btn outlined blue' onClick={this.toggleInvoiceSpecification}>
        <Translate content={translationKey}/>
      </button>
    );
  }

  renderInvoiceSpecification = () => {
    return (
      <div className="invoice-specification">
        <table>
          <tbody>
            {(this.props.payment.invoice.data.calculation.is_rot ||
              this.props.payment.invoice.data.calculation.is_rut) &&
              <tr>
                <td><Translate content={'PAYMENT_INVOICE_ROT_OR_RUT_DEDUCTION'}/>:</td>
                <td>
                  {this.props.payment.invoice.data.calculation.household_service_deducted_amount_including_vat}&nbsp;
                  {this.props.payment.invoice.data.currencyName}
                </td>
              </tr>
            }
            <tr>
              <td><Translate content={'PAYMENT_START_INVOICE_AMOUNT_EXCL'}/>:</td>
              <td>
                {this.props.payment.invoice.data.calculation.amount} {this.props.payment.invoice.data.currencyName}
              </td>
            </tr>
            <tr>
              <td><Translate content={'VAT'}/> ({this.props.payment.invoice.data.taxPercent}%):</td>
              <td>{this.props.payment.invoice.data.calculation.vat} {this.props.payment.invoice.data.currencyName}</td>
            </tr>
            <tr>
              <td><Translate content={'PAYMENT_START_INVOICE_AMOUNT_INCL'}/>:</td>
              <td>
                {this.props.payment.invoice.data.calculation.amount_including_vat}
                &nbsp;
                {this.props.payment.invoice.data.currencyName}
              </td>
            </tr>
          </tbody>
        </table>
        <a href={this.props.payment.invoice.data.pdfLink} className="btn btn-sm invoice-specification-download">
          <Translate content={'PAYMENT_DOWNLOAD_PDF'}/>
        </a>
      </div>
    );
  }

  renderPlusgiroButton = () => {
    let translationKey = this.state.showPlusgiroInfo ? 'MINIMIZE' : 'PAY_WITH_PLUSGIRO';
    return (
      <button className='btn outlined blue' onClick={this.togglePlusgiroInfo}>
        <Translate content={translationKey}/>
      </button>
    );
  }

  renderPlusgiroInfo = () => {
    return (
      <div className='plusgiro-info'>
        <div className='plusgiro-info-text'><Translate content={'PAYMENT_PAY_WITH_PLUSGIRO'}/></div>
        <table>
          <tbody>
            <tr>
              <td><Translate content='PLUSGIRO'/>:</td>
              <td><Translate content={'PLUSGIRO_NUMBER'}/></td>
            </tr>
            <tr>
              <td><Translate content='PLUSGIRO_RECIPIENT'/>:</td>
              <td><Translate content='PLUSGIRO_RECIPIENT_NAME'/></td>
            </tr>
            <tr>
              <td><Translate content='OCR'/>:</td>
              <td>{this.props.payment.invoice.data.ocr}</td>
            </tr>
            <tr>
              <td><Translate content='PAYMENT_PAGE_TO_PAY'/>:</td>
              <td>
                {Math.round(this.props.payment.invoice.data.calculation.amount_including_vat)}&nbsp;
                {this.props.payment.invoice.data.currencyName}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  render = () => {
    const name =
      `${this.props.payment.invoice.data.users.first_name} ${this.props.payment.invoice.data.users.last_name}`;
    return (
      <div className='payment-page'>
        <header>
          <Translate content='PAY_WITH_SWISH'/>
        </header>
        <section className='logo'>
          <img src={require('images/logos/logo-blue-new.png')} alt='Frilans Finans-logotyp' />
        </section>
        <section className='specification'>
          <div className="specification-from">
            <Translate name={name} content='PAYMENT_START_FROM_NAME'/>
          </div>
          <div className="specification-description">{this.props.payment.invoice.data.specification}</div>
          <div className="specification-amount">
            <Translate content='PAYMENT_PAGE_TO_PAY'/>:&nbsp;
            {Math.round(this.props.payment.invoice.data.calculation.amount_including_vat)}&nbsp;
            {this.props.payment.invoice.data.currencyName}
          </div>
        </section>
        <section className='buttons'>
          <a className='btn' onClick={this.startPayment}><Translate content='PAY_WITH_SWISH'/></a>
          {this.renderInvoiceSpecificationButton()}
          {this.state.showInvoiceSpecification &&
            this.renderInvoiceSpecification()
          }
          {this.renderPlusgiroButton()}
          {this.state.showPlusgiroInfo &&
            this.renderPlusgiroInfo()
          }
        </section>
        <footer>
          <a className='generic-link' onClick={this.props.cancel}><Translate content='CANCEL'/></a>
        </footer>
      </div>
    );
  }
}

export default PaymentStart;



/** WEBPACK FOOTER **
 ** ./src/views/payment/payment-start.js
 **/